{
  "menuItems": {
    "products": "Products",
    "salesChannels": "Sales Channels",
    "adminSettings": "Admin",
    "bundles": "Bundles"
  },
  "userMenu": {
    "logoutButtonLabel": "Log out"
  }
}
